import { render, staticRenderFns } from "./CardSelection.vue?vue&type=template&id=55b17bb4&scoped=true"
import script from "./CardSelection.vue?vue&type=script&lang=js"
export * from "./CardSelection.vue?vue&type=script&lang=js"
import style0 from "./CardSelection.vue?vue&type=style&index=0&id=55b17bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b17bb4",
  null
  
)

export default component.exports